import { Injectable } from '@angular/core';
import {
    LayoutGapParent,
    LayoutGapStyleBuilder,
    StyleDefinition
} from '@angular/flex-layout';

/**
 * https://stackoverflow.com/questions/60175336/uncaught-typeerror-cannot-read-property-endswith-of-undefined-at-layoutgapsty
 *
 * Issue with not providing default rules for gap rules in the layout.  This overrides the default behavior from
 * FlexLayout and provides a default gap when one is needed (0 px).
 */
@Injectable({
    providedIn: 'root'
})
export class CustomLayoutGapStyleBuilderService extends LayoutGapStyleBuilder {
    buildStyles(gapValue: string, parent: LayoutGapParent): StyleDefinition {
        return super.buildStyles(gapValue || '0 px', parent);
    }

    sideEffect(
        gapValue: string,
        _styles: StyleDefinition,
        parent: LayoutGapParent
    ) {
        return super.sideEffect(gapValue || '0 px', _styles, parent);
    }
}
